"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const fa_1 = require("react-icons/fa");
const ToolTip_1 = __importDefault(require("./ToolTip/ToolTip"));
const styles = {
    button: {
        backgroundColor: 'transparent',
        border: 'none',
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    svg: {
        fill: '#ca0000',
        fontSize: '16px',
    },
};
function CloseButton(props) {
    const { onClick = () => null, popupTitle = 'Close', popupPlacement = 'left', className = '', } = props;
    return ((0, jsx_runtime_1.jsx)("div", { className: className, children: (0, jsx_runtime_1.jsx)(ToolTip_1.default, { title: popupTitle, popupPlacement: popupPlacement, children: (0, jsx_runtime_1.jsx)("button", { style: styles.button, type: "button", onClick: onClick, children: (0, jsx_runtime_1.jsx)(fa_1.FaTimes, { style: styles.svg }) }) }) }));
}
exports.default = (0, react_1.memo)(CloseButton);
